import LandingPage from './landing-page/LandingPage';
import { BrowserRouter,Route,Routes,Navigate } from 'react-router-dom';
import SignIn from './sign-in/SignIn';
import SignUp from './sign-up/SignUp';
import {CheckoutForm,Return} from './landing-page/components/NewCheckout';
import {
  ContextFromSelectionsProvider,
  FetchedDataContextProvider,
  NotificationsProvider,
  CreateRoute,
  ReadyToCheckoutProvider,
  ShoppingCartContextProvider,
  
  } from './landing-page/components/Context';
import UserOrdersDataGrid from './landing-page/components/UserOrdersDataGrid';
import AccountSettings from './landing-page/components/AccountSettings';
import { useContext } from 'react';
import Layout from './landing-page/components/Layout';
import ResetPassword from './sign-up/ResetPassword';
import About from './landing-page/components/About';
import Contacts from './landing-page/components/Contacts';
import ShopCart from './landing-page/components/ShopCart';

function App() {
  
  const [params] = useContext(CreateRoute);


 

  return (
    
    <FetchedDataContextProvider>
        <ContextFromSelectionsProvider>
          <NotificationsProvider>
            <ReadyToCheckoutProvider>
              <ShoppingCartContextProvider>
                <BrowserRouter>
                  <Routes>
                      <Route element={<Layout/>}>
                    
                        <Route path="/" element={<LandingPage/>}/>
                        <Route path="/orders" element={<UserOrdersDataGrid/>}/> 
                        <Route path="/account" element={<AccountSettings/>}/> 
                        <Route path="/about" element={<About/>}/>
                        <Route path="/contacts" element={<Contacts/>}/>
                        <Route path="/shopcart" element={<ShopCart/>}/>
                      
                      </Route>
                    <Route path="/return" element={<Return />} />
                    <Route path="/signin" element={<SignIn/> } />
                    <Route path="/signup" element={<SignUp/> } />
                    <Route path="/resetpassword/:token" element={<ResetPassword/> } />
                    <Route path="/checkout" element={<CheckoutForm />}/>
                    {params.path && <Route path={params.path} element={<params.element options={params.params}/>} />}
                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                </BrowserRouter>
              </ShoppingCartContextProvider>
            </ReadyToCheckoutProvider>
          </NotificationsProvider>
      </ContextFromSelectionsProvider>
  </FetchedDataContextProvider>

            
           
            

           
        
 
  );
}

export default App;
